import { cn } from '@/lib/cn';
import type { HTMLAttributes } from 'react';

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'accent' | 'outline' | 'muted';
}

const VARIANT_CLASS: Record<NonNullable<BadgeProps['variant']>, string> = {
  default: 'bg-surface-muted text-foreground border border-border',
  accent: 'bg-accent/15 text-accent border border-accent/40',
  outline: 'bg-transparent text-foreground-muted border border-border',
  muted: 'bg-surface-muted/60 text-foreground-muted border border-border/60',
};

export function Badge({ className, variant = 'default', ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium leading-none',
        VARIANT_CLASS[variant],
        className,
      )}
      {...props}
    />
  );
}
